/* Wine Cooler Collection — Theme JS */
(function(){
'use strict';

const $  = (s,c=document)=>c.querySelector(s);
const $$ = (s,c=document)=>[...c.querySelectorAll(s)];
const on = (el,e,fn,opt)=>el&&el.addEventListener(e,fn,opt);
const fmt = c=>new Intl.NumberFormat('en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(c/100);

const BD = $('#Backdrop');
const openBD  = ()=>{BD?.classList.add('open');document.body.style.overflow='hidden'};
const closeBD = ()=>{BD?.classList.remove('open');document.body.style.overflow=''};
on(BD,'click',closeAll);

const CD = $('#CartDrawer');
const fetchCart = ()=>fetch('/cart.js').then(r=>r.json());

function renderCart(cart){
  const body = $('.cd-body');
  const subs = $$('.js-sub');
  const cnts = $$('.cart-badge');
  if(body){
    if(!cart.item_count){
      body.innerHTML='<p class="cd-empty">Your cart is empty.</p>';
    } else {
      body.innerHTML=cart.items.map(item=>`
        <div class="ci">
          <img class="ci-img" src="${item.image}" alt="${item.product_title}" loading="lazy" width="68" height="68">
          <div>
            <p class="ci-title">${item.product_title}</p>
            ${item.variant_title&&item.variant_title!=='Default Title'?`<p class="ci-variant">${item.variant_title}</p>`:''}
            <div class="ci-row">
              <span class="ci-price">${fmt(item.line_price)}</span>
              <button class="ci-rm" data-key="${item.key}" aria-label="Remove ${item.product_title}">Remove</button>
            </div>
          </div>
        </div>`).join('');
      $$('.ci-rm',body).forEach(b=>on(b,'click',()=>changeItem(b.dataset.key,0)));
    }
  }
  subs.forEach(el=>el.textContent=fmt(cart.total_price));
  cnts.forEach(el=>{el.textContent=cart.item_count;el.style.display=cart.item_count?'flex':'none'});
}

async function openCart(){
  if(!CD)return;
  renderCart(await fetchCart());
  CD.classList.add('open');
  CD.setAttribute('aria-hidden','false');
  openBD();
}
function closeCart(){CD?.classList.remove('open');CD?.setAttribute('aria-hidden','true')}
async function changeItem(key,qty){
  const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
  renderCart(await r.json());
}
async function addToCart(id,qty=1){
  const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity:qty})});
  if(!r.ok){const e=await r.json();throw new Error(e.description||'Could not add to cart')}
  renderCart(await fetchCart());
  openCart();
}

$$('[data-cart-open]').forEach(el=>on(el,'click',openCart));
$$('[data-cart-close]').forEach(el=>on(el,'click',()=>{closeCart();closeBD()}));

$$('[data-atc-form]').forEach(form=>{
  on(form,'submit',async e=>{
    e.preventDefault();
    const btn=form.querySelector('[data-atc-btn]');
    const idEl=form.querySelector('[name="id"]');
    const errEl=form.querySelector('.atc-err');
    if(!idEl)return;
    const orig=btn?.innerHTML;
    if(btn){btn.disabled=true;btn.innerHTML='<span class="wcc-spin"></span>'}
    if(errEl)errEl.style.display='none';
    try{await addToCart(idEl.value)}
    catch(err){if(errEl){errEl.textContent=err.message;errEl.style.display='block'}}
    finally{if(btn){btn.disabled=false;btn.innerHTML=orig}}
  });
});

const MN = $('#MobNav');
const openMN  = ()=>{MN?.classList.add('open');MN?.setAttribute('aria-hidden','false');openBD()};
const closeMN = ()=>{MN?.classList.remove('open');MN?.setAttribute('aria-hidden','true');closeBD()};
$$('[data-menu-open]').forEach(el=>on(el,'click',openMN));
$$('[data-menu-close]').forEach(el=>on(el,'click',closeMN));

function closeAll(){closeCart();closeMN();closeBD()}

const GAL = $('#PdpGallery');
if(GAL){
  /* #GalleryMainImg, not #GalleryMain. The id this file queried does not exist
     in wcc-product.liquid, so mainImg was always null: thumbnail clicks moved
     the highlight ring but never swapped the photo. Clarity (30d to
     2026-10-22) shows shoppers rapid-clicking thumbs until a dead click, and
     every mobile tap recorded on the top product page landed on this gallery. */
  const mainImg=$('#GalleryMainImg',GAL);
  $$('.g-thumb',GAL).forEach(t=>{
    on(t,'click',()=>{
      if(mainImg){mainImg.src=t.dataset.src;mainImg.alt=t.dataset.alt||''}
      $$('.g-thumb',GAL).forEach(x=>x.classList.remove('on'));
      t.classList.add('on');
    });
  });
  /* Click-to-zoom. PC sessions click the main photo expecting zoom and Clarity
     logs those as dead clicks on a $1,799 page. The overlay's z-index must
     clear #wccai's 2147483000 (see the sticky-ATC note below) or the widget
     eats the close click. Not a form, so the bot-protection init-time rule
     that forbids JS-injected forms does not apply to this element. */
  if(mainImg){
    mainImg.style.cursor='zoom-in';
    on(mainImg,'click',()=>{
      const ov=document.createElement('div');
      ov.className='wcc-lb';
      ov.setAttribute('role','dialog');
      ov.setAttribute('aria-label','Image zoom. Click or press Escape to close.');
      const big=document.createElement('img');
      big.src=mainImg.src.replace('width=900','width=1800');
      big.alt=mainImg.alt||'';
      ov.appendChild(big);
      const esc=e=>{if(e.key==='Escape')close()};
      const close=()=>{ov.remove();document.removeEventListener('keydown',esc);document.body.style.overflow=''};
      on(ov,'click',close);
      document.addEventListener('keydown',esc);
      document.body.style.overflow='hidden';
      document.body.appendChild(ov);
    });
  }
}

/* PDP tabs (desktop) + accordion (mobile) */
$$('[data-tabs]').forEach(wrap=>{
  const navBtns=$$('.tab-btn',wrap);
  const panels=$$('.tab-panel',wrap);
  const heads=$$('.tab-head',wrap);
  const activateByIdx=i=>{
    navBtns.forEach((b,j)=>{b.classList.toggle('on',i===j);b.setAttribute('aria-selected',i===j?'true':'false')});
    panels.forEach((p,j)=>p.classList.toggle('on',i===j));
    heads.forEach((h,j)=>h.setAttribute('aria-expanded',i===j?'true':'false'));
  };
  navBtns.forEach((btn,i)=>{on(btn,'click',()=>activateByIdx(i))});
  heads.forEach((head,i)=>{
    on(head,'click',()=>{
      const panel=panels[i];
      const isOpen=panel&&panel.classList.contains('on');
      if(isOpen){
        panel.classList.remove('on');
        head.setAttribute('aria-expanded','false');
        navBtns.forEach(b=>{b.classList.remove('on');b.setAttribute('aria-selected','false')});
      } else {
        activateByIdx(i);
        setTimeout(()=>head.scrollIntoView({behavior:'smooth',block:'start'}),120);
      }
    });
  });
});

$$('.acc-item').forEach(item=>{
  const trig=$('.acc-trig',item);
  const body=$('.acc-body',item);
  on(trig,'click',()=>{
    const open=trig.classList.toggle('on');
    body.classList.toggle('on',open);
    trig.setAttribute('aria-expanded',open);
  });
});

on($('#FilterToggle'),'click',()=>$('#FilterSidebar')?.classList.toggle('open'));

const FF=$('#FilterForm');
if(FF){
  let deb;
  on(FF,'change',()=>{clearTimeout(deb);deb=setTimeout(applyFilters,380)});
  function applyFilters(){
    const url=new URL(window.location.href);
    const fd=new FormData(FF);
    /* Clear every filter key rather than a hand-maintained list. The old list
       left out filter.v.availability, so it accumulated a duplicate on every
       change: ?filter.v.availability=1&filter.v.availability=1&... */
    [...url.searchParams.keys()].forEach(k=>{
      if(k.indexOf('filter.')===0||k==='sort_by')url.searchParams.delete(k);
    });
    for(const[k,v]of fd.entries()){
      if(!v)continue;
      /* '0' is truthy as a string. Unguarded it sent gte=0&lte=0, a zero-to-zero
         price band, so ticking one availability box emptied the collection. */
      if((k==='filter.v.price.gte'||k==='filter.v.price.lte')&&!(parseFloat(v)>0))continue;
      url.searchParams.append(k,v);
    }
    history.pushState({},'',url.toString());
    refreshGrid(url.toString());
  }
  const emptyMsg=t=>'<p class="coll-empty" role="status" style="padding:2.5rem 0;color:var(--muted,#666)">'
    +t+' <a href="'+window.location.pathname+'">Clear all filters</a></p>';
  async function refreshGrid(url){
    const grid=$('#CollGrid');
    if(!grid)return;
    grid.style.opacity='.4';
    try{
      const res=await fetch(`${url}&sections=wcc-collection`);
      const data=await res.json();
      const tmp=document.createElement('div');
      tmp.innerHTML=data['wcc-collection']||'';
      const ng=tmp.querySelector('#CollGrid');
      /* No #CollGrid means the filters matched nothing and the section rendered
         its empty state. Say so rather than leaving stale results under a veil. */
      grid.innerHTML=ng?ng.innerHTML:emptyMsg('No products match those filters.');
    }catch(e){
      grid.innerHTML=emptyMsg('Those results could not be loaded.');
    }finally{
      /* Unconditional. The loader veil watches this value, so every exit path
         must restore it or the overlay never goes away. */
      grid.style.opacity='1';
    }
  }
  on(window,'popstate',()=>refreshGrid(window.location.href));
}

$$('[data-vgroup]').forEach(g=>{
  $$('.vbtn',g).forEach(b=>{
    on(b,'click',()=>{
      $$('.vbtn',g).forEach(x=>x.classList.remove('on'));
      b.classList.add('on');
      const lab=g.parentElement&&g.parentElement.querySelector('.vgroup-label strong');
      if(lab)lab.textContent=b.dataset.value;
      updateVariant();
    });
  });
});
function updateVariant(){
  if(!window.__WCC_V__)return;
  const sel=$$('[data-vgroup]').map(g=>$('.vbtn.on',g)?.dataset.value);
  const match=window.__WCC_V__.find(v=>v.options.every((o,i)=>o===sel[i]));
  if(!match)return;
  const idEl=$('[name="id"]');
  const pr=$('#PdpPrice');
  const cp=$('#PdpCompare');
  const sv=$('#PdpSavings');
  const btn=$('[data-atc-btn]');
  if(idEl)idEl.value=match.id;
  if(pr)pr.textContent=fmt(match.price);
  const hasComp=match.compare_at_price>match.price;
  if(cp){cp.style.display=hasComp?'':'none';if(hasComp)cp.textContent=fmt(match.compare_at_price)}
  if(sv){sv.style.display=hasComp?'':'none';if(hasComp)sv.textContent='Save '+fmt(match.compare_at_price-match.price)}
  if(btn){btn.disabled=!match.available;btn.textContent=match.available?'Add to Cart · Free Shipping':'Out of Stock'}
  /* The capture form is present in the document for any product with a sold-out
     variant and is only shown/hidden here. It must not be created by JS: this
     store's bot protection binds at page init, and a JS-injected form submits
     silently into nothing. Verified the hard way on the quote form, 2026-09-09. */
  const bis=$('[data-bis]');
  if(bis){
    bis.hidden=!!match.available;
    const bodyEl=$('#WccBisBody');
    if(bodyEl){
      bodyEl.value='Back-in-stock request.\n\nProduct: '+document.title.split(' · ')[0]
        +'\nVariant: '+(match.title||'')
        +'\nSKU: '+(match.sku||'not set')
        +'\nURL: '+(location.origin+location.pathname);
    }
  }
}

const SATC=$('#StickyAtc');
const AnchorEl=$('#AtcAnchor');
if(SATC&&AnchorEl){
  /* The assistant widget (#wccai) is injected by an app embed, not by this
     theme, at bottom:18px with z-index 2147483000. On desktop that lands it
     exactly on top of this bar's Add to Cart button and it wins the stacking
     contest by nine orders of magnitude, so the primary buy control on a
     scrolled product page is unclickable. The app lifts it itself below
     900px, which is why this only ever showed up on desktop.

     We cannot restyle the widget at source, so we publish the bar's state and
     real height and let the stylesheet move the widget clear. Height is
     measured rather than hard-coded because the bar grows when its title
     appears below 900px. */
  const obs=new IntersectionObserver(([e])=>{
    const up=!e.isIntersecting;
    SATC.classList.toggle('show',up);
    document.body.classList.toggle('satc-up',up);
    /* Set the lift inline rather than from a stylesheet. A rule of the form
       `body.satc-up #wccai{transform:...!important}` is matched by the widget
       and still computes to the identity matrix, measured repeatedly on the
       live page 2026-09-12 across every calc and plain-px spelling. An inline
       transform on the same element applies immediately and correctly. Cause
       not isolated; this is the spelling that verifiably works.

       The widget is looked up on each call, not cached, because an app embed
       injects it and it may not exist when this file first runs. */
    const AI=document.getElementById('wccai');
    if(AI)AI.style.setProperty('transform',up?'translateY(-'+SATC.offsetHeight+'px)':'none','important');
  });
  obs.observe(AnchorEl);
  on($('[data-sticky-atc]',SATC),'click',()=>$('[data-atc-form]')?.dispatchEvent(new Event('submit')));
}

document.addEventListener('DOMContentLoaded',()=>{
  fetchCart().then(cart=>{
    $$('.cart-badge').forEach(el=>{el.textContent=cart.item_count;el.style.display=cart.item_count?'flex':'none'});
  });
});

/* Grid carousel (best sellers, related) */
$$('[data-carousel-grid]').forEach(wrap=>{
  const track=$('.wcc-car-track',wrap);
  const slides=$$('.wcc-car-slide',track);
  const dotsWrap=$('.wcc-car-dots',wrap);
  if(!track||slides.length<2)return;
  const slideWidth=()=>{var s=slides[0];if(!s)return 0;var r=s.getBoundingClientRect();return r.width+16};
  slides.forEach((_,i)=>{
    const d=document.createElement('button');d.className='wcc-car-dot';d.type='button';
    d.setAttribute('aria-label','Go to slide '+(i+1));d.setAttribute('role','tab');
    if(i===0){d.classList.add('on');d.setAttribute('aria-selected','true')}
    on(d,'click',()=>{track.scrollTo({left:slideWidth()*i,behavior:'smooth'})});
    dotsWrap?.appendChild(d);
  });
  const dots=$$('.wcc-car-dot',dotsWrap);
  let ticking=false;
  on(track,'scroll',()=>{
    if(ticking)return;
    ticking=true;
    requestAnimationFrame(()=>{
      const i=Math.round(track.scrollLeft/Math.max(1,slideWidth()));
      dots.forEach((d,j)=>{d.classList.toggle('on',j===i);d.setAttribute('aria-selected',j===i)});
      ticking=false;
    });
  },{passive:true});
  const arrows=$$('.wcc-car-prev,.wcc-car-next',wrap);
  arrows.forEach(btn=>{
    on(btn,'click',()=>{
      const dir=btn.classList.contains('wcc-car-prev')?-1:1;
      track.scrollBy({left:slideWidth()*dir,behavior:'smooth'});
    });
  });
  /* Only offer the controls when there is somewhere to scroll. Inline display is
     deliberate: the [hidden] attribute loses to the .wcc-car-next class rule on
     specificity order, so it would not have hidden anything. */
  const syncArrows=()=>{
    const scrollable=track.scrollWidth>track.clientWidth+1;
    arrows.forEach(b=>{b.style.display=scrollable?'':'none'});
    if(dotsWrap)dotsWrap.style.display=scrollable?'':'none';
  };
  syncArrows();
  on(window,'resize',syncArrows);
  if('ResizeObserver'in window)new ResizeObserver(syncArrows).observe(track);
});

/* Fade carousel (testimonials, reviews) */
$$('[data-carousel-fade]').forEach(wrap=>{
  const slides=$$('.wcc-fc-slide',wrap);
  const dotsWrap=$('.wcc-fc-dots',wrap);
  if(slides.length<2)return;
  let active=0;
  let timer=null;
  const dots=[];
  slides.forEach((_,i)=>{
    const d=document.createElement('button');d.className='wcc-fc-dot';d.type='button';
    d.setAttribute('aria-label','Go to review '+(i+1));d.setAttribute('role','tab');
    if(i===0){d.classList.add('on');d.setAttribute('aria-selected','true')}
    on(d,'click',()=>{go(i);reset()});
    dotsWrap?.appendChild(d);dots.push(d);
  });
  const go=i=>{
    active=(i+slides.length)%slides.length;
    slides.forEach((s,j)=>s.classList.toggle('on',j===active));
    dots.forEach((d,j)=>{d.classList.toggle('on',j===active);d.setAttribute('aria-selected',j===active)});
  };
  $$('.wcc-fc-prev,.wcc-fc-next',wrap).forEach(btn=>{
    on(btn,'click',()=>{
      const dir=btn.classList.contains('wcc-fc-prev')?-1:1;
      go(active+dir);reset();
    });
  });
  const start=()=>{if(timer)return;timer=setInterval(()=>go(active+1),6500)};
  const stop=()=>{if(timer){clearInterval(timer);timer=null}};
  const reset=()=>{stop();start()};
  on(wrap,'mouseenter',stop);on(wrap,'mouseleave',start);
  on(wrap,'focusin',stop);on(wrap,'focusout',start);
  on(wrap,'touchstart',stop,{passive:true});
  if('IntersectionObserver' in window){
    new IntersectionObserver(([e])=>{e.isIntersecting?start():stop()}).observe(wrap);
  } else start();
});

/* Spinner + lightbox CSS */
const st=document.createElement('style');
st.textContent='@keyframes wcc-s{to{transform:rotate(360deg)}}.wcc-spin{display:inline-block;width:18px;height:18px;border:2px solid rgba(255,255,255,.3);border-top-color:#fff;border-radius:50%;animation:wcc-s .65s linear infinite}'
+'.wcc-lb{position:fixed;inset:0;z-index:2147483100;background:rgba(17,20,24,.93);display:flex;align-items:center;justify-content:center;cursor:zoom-out;padding:2vmin}.wcc-lb img{max-width:96vw;max-height:96vh;width:auto;height:auto}';
document.head.appendChild(st);

})();